import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';
import { ReactNode, useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { IconType } from '../Icon/Icon.types.js';
import Icon from '../Icon/index.js';
import Typography from '../Typography/index.js';

export interface MessageProps {
  children: ReactNode;
  variant: 'info' | 'warning' | 'error' | 'success';
  id?: string;
}

const VARIANT_PROPS: {
  [variant in MessageProps['variant']]: {
    icon: IconType;
    iconColor: Color;
    backgroundColor: string;
  };
} = {
  info: {
    icon: 'info',
    iconColor: Color.Primary,
    backgroundColor: BackgroundColors[Color.GrayBackground],
  },
  // TODO: Add new colors to theme
  warning: { icon: 'warning', iconColor: Color.Warning, backgroundColor: 'bg-[#FFF9E7]' },
  error: { icon: 'error', iconColor: Color.Error, backgroundColor: 'bg-[#FDF1F1]' },
  success: { icon: 'checkCircle', iconColor: Color.Success, backgroundColor: 'bg-[#EDF7ED]' },
};

export default function Message({ children, variant, id }: MessageProps): JSX.Element {
  const { icon, iconColor: color, backgroundColor } = VARIANT_PROPS[variant];
  const alertProps = variant === 'error' ? { role: 'alert' } : {};
  const defaultId = useRef(uuidv4());
  return (
    <div className={cx(backgroundColor, 'p-4 rounded-sm inline-flex gap-2')} {...alertProps}>
      <Icon type={icon} color={color} size="LG" />
      <div className="mt-[2px]">
        <Typography variant="body" id={id || defaultId.current}>
          {children}
        </Typography>
      </div>
    </div>
  );
}
